import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.n{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.cm{background:var(--shades-white);}.ssr-plugin'
import '.br{flex-grow:1;}.ssr-plugin'
import '.e{align-items:center;}.ssr-plugin'
import '.bd{max-width:77.5rem;}.ssr-plugin'
import '.dm{justify-content:stretch;}.ssr-plugin'
import '.dn{position:sticky;}.ssr-plugin'
import '.cg{top:0;}.ssr-plugin'
import '.do{z-index:10;}.ssr-plugin'
import '.dp{padding-block:1rem;}.ssr-plugin'
import '.dq{height:3rem;}.ssr-plugin'
import '.x{justify-content:space-between;}.ssr-plugin'
import '.dr{flex-wrap:wrap;}.ssr-plugin'
import '.ds{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bb{margin-top:2rem;}.ssr-plugin'
import '.gj{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab n b cm"
      >
        <div className="br a e n b"
        >
          <div className="bd a b dm dn cg do"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="dp dq a x e dr"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="ds a b ab bb gj bd"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
